import { gsap, Power3 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
require('./SplitText')

import store from '../modules/store'

export default class Animizi {
    constructor() {
        this.bottomTrigger = '90%'
        this.tweens = []

        // register ScrollTrigger
        gsap.registerPlugin(ScrollTrigger)
        gsap.ticker.add(store.asscroll.update)

        // Use this.asscroll as scroll for gsap
        ScrollTrigger.defaults({
            scroller: store.asscroll.containerElement
        })
        ScrollTrigger.scrollerProxy(store.asscroll.containerElement, {
            scrollTop(value) {
                return arguments.length ? store.asscroll.currentPos = value : store.asscroll.currentPos
            },
            getBoundingClientRect() {
                return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }
            }
        })

        store.asscroll.on('update', ScrollTrigger.update)
        ScrollTrigger.addEventListener('refresh', store.asscroll.resize)
    }

    addTopImage(el, resolve) {
        const tween = gsap.from(el, {
            y: 100,
            duration: 1.5,
            ease: Power3.easeInOut,
            onComplete: resolve
        })
        this.tweens.push(tween)
    }
    addTopParallax(el) {
        const tween = gsap.to(el, {
            scrollTrigger: {
                start: "top top", // when the top of the trigger hits the top of the viewport
                end: "bottom top",
                scrub: 0,
                trigger: el
            },
            y: 120,
            ease: "none"
        })
        this.tweens.push(tween)
    }
    addHeading1(el, delay = 0) {
        // Split
        const title = this.splitTitle(el)
        // Animate
        el.style.opacity = 1
        title.words.forEach((word, index) => {
            const tween = gsap.from(word, {
                y: '100%',
                ease: Power3.easeOut,
                duration: 1.2,
                delay: delay + index / 7
            })
            this.tweens.push(tween)
        })
    }
    addHeading1Bis(el, delay = 0) {
        // Split
        const title = this.splitTitle(el)
        // Animate
        el.style.opacity = 1
        title.lines.forEach((line, index) => {
            const tween = gsap.from(line.children, {
                y: '100%',
                ease: Power3.easeOut,
                duration: 1.2,
                delay: delay + index / 5
            })
            this.tweens.push(tween)
        })
    }
    addHeading2(el) {
        // Split
        const title = this.splitTitle(el)
        // Animate
        el.style.opacity = 1
        title.lines.forEach((line, index) => {
            const tween = gsap.from(line.children, {
                scrollTrigger: {
                    trigger: el,
                    start: `top ${this.bottomTrigger}`,
                    end: `top ${this.bottomTrigger}`
                },
                y: '100%',
                delay: index / 5,
                ease: Power3.easeOut,
                duration: 1.2
            })
            this.tweens.push(tween)
        })
    }
    addHeading2bis(el) {
        // Split
        const title = this.splitTitle(el)
        // Animate
        el.style.opacity = 1
        title.words.forEach((word, index) => {
            const tween = gsap.from(word, {
                scrollTrigger: {
                    trigger: el,
                    start: `top ${this.bottomTrigger}`,
                    end: `top ${this.bottomTrigger}`
                },
                y: '100%',
                delay: index / 7,
                ease: Power3.easeOut,
                duration: 1.2
            })
            this.tweens.push(tween)
        })
    }
    addTopText(el, delay = 0) {
        // Split
        const text = this.splitText(el)
        // Animate
        el.style.opacity = 1
        text.lines.forEach((line, index) => {
            const tween = gsap.from(line.children, {
                y: '100%',
                ease: Power3.easeOut,
                duration: 1.2,
                delay: delay + index / 5
            })
            this.tweens.push(tween)
        })
    }
    addText(el) {
        // Split
        const text = this.splitText(el)
        // Animate
        el.style.opacity = 1
        text.lines.forEach((line, index) => {
            const tween = gsap.from(line.children, {
                scrollTrigger: {
                    trigger: el,
                    start: `top ${this.bottomTrigger}`,
                    end: `top ${this.bottomTrigger}`
                },
                y: '100%',
                delay: index / 5,
                ease: Power3.easeOut,
                duration: 1.2
            })
            this.tweens.push(tween)
        })
    }
    addParallax(el) {
        gsap.set(el, { y: -80 })
        const tween = gsap.to(el, {
            scrollTrigger: {
                start: "top bottom", // when the top of the trigger hits the top of the viewport
                end: "bottom top",
                scrub: 0,
                trigger: el.parentNode
            },
            y: 80,
            ease: "none"
        })
        this.tweens.push(tween)
    }
    addRealization(el) {
        // Animate
        el.style.opacity = 1
        // Title
        const tween = gsap.from(el.querySelector('.m-view-realizations_bloc_title'), {
            scrollTrigger: {
                trigger: el,
                start: `top ${this.bottomTrigger}`,
                end: `top ${this.bottomTrigger}`
            },
            y: '100%',
            ease: Power3.easeOut,
            duration: 1.2
        })
        this.tweens.push(tween)
    }
    addAccordion(el) {
        // Animate
        el.style.opacity = 1
        // Title
        const tween = gsap.from(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top bottom',
                end: 'top bottom'
            },
            y: '100%',
            ease: Power3.easeOut,
            duration: 1.2
        })
        this.tweens.push(tween)
    }
    addMarket(el) {
        // Split
        const title = this.split(el.querySelector('.m-markets_title'))
        // Animate
        el.style.opacity = 1
        // Icon
        const tween = gsap.from(el.querySelector('.m-markets_icon'), {
            scrollTrigger: {
                trigger: el,
                start: `top ${this.bottomTrigger}`,
                end: `top ${this.bottomTrigger}`
            },
            y: '100%',
            ease: Power3.easeOut,
            duration: 1.2
        })
        this.tweens.push(tween)
        // Title
        title.words.forEach((word, index) => {
            const tween = gsap.from(word, {
                scrollTrigger: {
                    trigger: el,
                    start: `top ${this.bottomTrigger}`,
                    end: `top ${this.bottomTrigger}`
                },
                y: '100%',
                delay: index / 7 + (1 / 7),
                ease: Power3.easeOut,
                duration: 1.2
            })
            this.tweens.push(tween)
        })
    }
    addKeyFigures(el) {
        // Split
        const figure = this.splitFigure(el.querySelector('.m-keyFigures_title'))
        // Animate
        el.style.opacity = 1
        // Title
        figure.chars.forEach((char, index) => {
            const tween = gsap.from(char, {
                scrollTrigger: {
                    trigger: el,
                    start: `top ${this.bottomTrigger}`,
                    end: `top ${this.bottomTrigger}`
                },
                y: '100%',
                delay: index / 7,
                ease: Power3.easeOut,
                duration: 1.2
            })
            this.tweens.push(tween)
        })
    }
    addRealizations(el) {
        if(el.parentNode.offsetHeight - el.offsetHeight <= 0)
            return false

        const tween = gsap.to(el, {
            scrollTrigger: {
                start: "top 25%",
                end: "bottom 75%",
                trigger: el.parentNode,
                scrub: 0.25,
                invalidateOnRefresh: true
            },
            y: () => el.parentNode.offsetHeight - el.offsetHeight,
            ease: "none"
        })
        this.tweens.push(tween)
    }

    split(el) {
        return new SplitText(el, {
            type: 'words'
        })
    }
    splitFigure(el) {
        return new SplitText(el, {
            type: 'words,chars',
            wordsClass: 'm-keyFigures_word',
            charsClass: 'm-keyFigures_chars'
        })
    }
    splitTitle(el) {
        el.classList.add('-splitted')
        return new SplitText(el, {
            type: 'lines,words',
            linesClass: 'a-heading_line',
            wordsClass: 'a-heading_word'
        })
    }
    splitText(el) {
        return new SplitText(el, {
            type: 'lines,words',
            linesClass: 'a-text_line',
            wordsClass: 'a-text_word'
        })
    }

    clean() {
        const triggers = ScrollTrigger.getAll()
        triggers.forEach(trigger => {
            trigger.kill(false)
        })
    }
}